import logo from '@/images/did_logo_dark.svg';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

const LogoContainer = styled.div`
    display: flex;
    padding: 20px 32px 40px;
    width: 100%;

    &:focus {
        outline: none;
    }
`;

const StyledLink = styled(Link)`
    &:focus {
        outline: none;
    }
`;

const StyledImage = styled.img`
    width: 48px;
`;

export const Logo = () => {
    return (
        <LogoContainer id="sidebar-logo">
            <StyledLink to="/">
                <StyledImage src={logo} alt="logo" />
            </StyledLink>
        </LogoContainer>
    );
};
